import { ComponentType } from 'react';

import { LAZY_LOAD_ATTEMPTS_LEFT, LAZY_LOAD_INTERVAL } from '@utilities/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LazyLoader = <T extends ComponentType<any>>(
  lazyComponent: () => Promise<{ default: T }>,
  attemptsLeft = LAZY_LOAD_ATTEMPTS_LEFT,
  interval = LAZY_LOAD_INTERVAL,
) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  new Promise<{ default: ComponentType<any> }>((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (attemptsLeft === 1) {
            reject(error);
            return;
          }
          LazyLoader(lazyComponent, attemptsLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });

export default LazyLoader;
